import { AfterViewInit, Component, ElementRef, HostListener, Input, NgZone, OnDestroy, OnChanges, QueryList, SimpleChanges, ViewChildren, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReportsService } from '../../reports.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { InbuiltReportModel, PageModel, TabModel } from '../../inbuilt-report-v2/Inbuilt-report-model';
import { SideMenuNode, SideMenuSelectEvent } from '../../../shared/components/sidemenu/sidemenu.model';
import { InbuiltUtilityService } from '../inbuilt-utility.service';
import { DailogModalComponent } from '../../../shared/elements/dailog-modal/dailog-modal.component';
import { Subject, fromEvent, startWith, takeUntil, auditTime } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TitleCasePipe, NgIf, NgClass, NgFor, NgSwitch, NgSwitchCase } from '@angular/common';
import { FILTER_ELEMENT_DEFAULT_JSON, OTHER_ELEMENT_DEFAULT_JSON } from './visual-json-templates';
import { SharedAuthService } from '../../../shared/shared.auth.service';
import { LoaderComponent } from '../../../shared/elements/loader/loader.component';
import { InbuiltPagesV2Component } from '../inbuilt-pages-v2/inbuilt-pages-v2.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { SideMenuComponent } from '../../../shared/components/sidemenu/sidemenu.component';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { InbuiltCustomReportComponent } from '../inbuilt-custom-report/inbuilt-custom-report.component';
import { InbuiltFiltersV2Component } from '../inbuilt-filters-v2/inbuilt-filters-v2.component';
import { InbuiltTableV2Component } from '../inbuilt-table-v2/inbuilt-table-v2.component';
import { InbuiltVisualWrapperV2Component } from '../inbuilt-visual-wrapper-v2/inbuilt-visual-wrapper-v2.component';
import { InbuiltMatrixV2Component } from '../inbuilt-matrix-v2/inbuilt-matrix-v2.component';
import { InbuiltDrillDownMatrixComponent } from '../inbuilt-drill-down-matrix/inbuilt-drill-down-matrix.component';
import { ParentChildTableComponent } from '../parent-child-table/parent-child-table.component';
import { ColumnChartV2Component } from '../column-chart-v2/column-chart-v2.component';
import { InbuiltBarChartV2Component } from '../inbuilt-bar-chart-v2/inbuilt-bar-chart-v2.component';
import { InbuiltHeaderV2Component } from '../inbuilt-donut-v2/inbuilt-donut-v2.component';
import { InbuiltCardV2Component } from '../inbuilt-card-v2/inbuilt-card-v2.component';
import { InbuiltSpeedometerV2Component } from '../inbuilt-speedometer-v2/inbuilt-speedometer-v2.component';
import { InbuiltStatCardComponent } from '../inbuilt-stat-card/inbuilt-stat-card.component';
import { InbuiltStackChartComponent } from '../inbuilt-stack-chart/inbuilt-stack-chart.component';
import { MatIcon } from '@angular/material/icon';
import { AppModalComponent } from '../../../shared/elements/app-modal/app-modal.component';
import { JsonEditorComponent } from '../../../shared/elements/json-editor/json-editor.component';
import { InbuiltEditorComponent } from '../../../shared/components/inbuilt-editor/inbuilt-editor.component';
import { FormsModule } from '@angular/forms';
interface VisualMenuItem {
  type: string;
  name: string;
  icon: string;
  alreadyDefined: boolean;
  tooltip: string;
}

@Component({
    selector: 'app-inbuilt-report-v2',
    templateUrl: './inbuilt-report-v2.component.html',
    styleUrls: ['./inbuilt-report-v2.component.css'],
    imports: [NgIf, LoaderComponent, RouterLink, InbuiltPagesV2Component, MatSlideToggle, NgClass, SideMenuComponent, MatTabGroup, NgFor, MatTab, InbuiltCustomReportComponent, NgSwitch, NgSwitchCase, InbuiltFiltersV2Component, InbuiltTableV2Component, InbuiltVisualWrapperV2Component, InbuiltMatrixV2Component, InbuiltDrillDownMatrixComponent, ParentChildTableComponent, ColumnChartV2Component, InbuiltBarChartV2Component, InbuiltHeaderV2Component, InbuiltCardV2Component, InbuiltSpeedometerV2Component, InbuiltStatCardComponent, InbuiltStackChartComponent, MatIcon, AppModalComponent, JsonEditorComponent, InbuiltEditorComponent, FormsModule, TitleCasePipe]
})

export class InbuiltReportV2Component implements AfterViewInit, OnDestroy, OnChanges, OnInit {
  @ViewChildren('widgetHost', { read: ElementRef }) widgetHosts!: QueryList<ElementRef<HTMLElement>>;
  @Input() reportNameFromInput: string = '';
  reportNameFromQueryParams: string = '';
  initialDataLoaded: boolean = false;
  showView: boolean = false;
  searchTriggered: boolean = false;
  pollTimer = null;
  
  isCurrentPageDataLoaded: boolean = false;
  isParentReportDataLoaded: boolean = false;
  isChildReportDataLoaded: boolean = false;
  isPageChanging: boolean = false;
  isTabLabelEmpty: boolean = false;
  pages: Array<PageModel> = [];
  currentPage: PageModel | null = null;
  currentTab: TabModel | null = null;
  /** True when the child report API returned no visuals for the currently loaded page/tab. */
  noElementsForTab: boolean = false;
  /** True when the sidemenu selection is a page/tab pending deletion (not yet saved) - shows a "not available" message instead. */
  selectedNodeUnavailable: boolean = false;
  unavailableNodeName: string = '';
  tableConfig: any = null;
  pageConfig: any = null;
  reportDocumentation: string = '';
  sideNavTheme: 'theme1' | 'theme2' = 'theme2';
  sideMenuExpanded: boolean = true;
  hasReportAdminRole: boolean = false;
  hasPageAccessRole: boolean = false;
  showJsonEditor: boolean = false;
  parentJSON: any = {};
  isJSONeditorPopupOpen: boolean = false;
  isAddVisualJsonPopupOpen: boolean = false;
  addVisualJsonData: any = {};
  selectedVisualType: string = '';
  showMenu: boolean = false;
  addVisualElementName: string = '';
  addVisualElementRank: number | null = null;
  addVisualElementWidth: number | null = null;
  /** True once a rank collision warning has been shown; clicking Save again proceeds and reorders the conflicting elements. */
  pendingRankConflict: boolean = false;
  duplicateElementExist: string = '';
  dataSourceJson: any = {};
  readonly addVisualMenuItems: SideMenuNode[] = [
    { id: 'json-editor', type: 'editor', name: 'Json-Editor' },
    { id: 'sql-query', type: 'query', name: 'SQL Query' }
  ];
  @ViewChild('addVisualMenuContainer') addVisualMenuContainerRef?: ElementRef<HTMLElement>;

  // Fixed set of visual types always offered in the "Visuals" segment (never disabled).
  private readonly visualElementTypes: any[] = [
    {key: 'table', value: 'Table'},
    {key: 'metrics', value: 'Metrics'},
    {key: 'drill_down_matrix', value: 'Drill Down Matrix'},
    {key: 'parent_child_table', value: 'Parent Child Table'},
    {key: 'column_chart', value: 'Column Chart'},
    {key: 'bar_chart', value: 'Bar Chart'},
    {key: 'card', value: 'Card'},
    {key: 'speedometer', value: 'Speedometer'},
    {key: 'stat_card', value: 'Stat Card'},
    {key: 'stack_chart', value: 'Stack Chart'}
  ];

  // Icon shown per element type in the "Add Visual JSON" menu; unmapped types fall back to a generic icon.
  private readonly elementTypeIcons: Record<string, string> = {
    filter: 'filter_alt',
    table: 'table_chart',
    stat_card: 'dashboard',
    header: 'title',
    stack_chart: 'stacked_bar_chart',
    metrics: 'analytics',
    speedometer: 'speed',
    bar_chart: 'bar_chart',
    card: 'crop_square',
    column_chart: 'insert_chart',
    donut_chart: 'donut_large',
    drill_down_matrix: 'grid_view',
    parent_child_table: 'account_tree'
  };
  @ViewChild('modalEditJSON', { static: false }) modalEditJSON: any;
  @ViewChild('modalAddVisualJSON', { static: false }) modalAddVisualJSON: any;
  selectedSecure: string[] = [];
  private readonly destroy$ = new Subject<void>();
  private resizeObserver: ResizeObserver | null = null;
  private resizeRafId: number | null = null;
  private isApplyingRowHeights = false;
  private readonly rowTopTolerance = 3;
  private readonly meaningfulHeightPx = 36;
  private readonly responsiveColClassMap: Record<number, string> = {
    1: 'col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 col-xxl-1',
    2: 'col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2',
    3: 'col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3',
    4: 'col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4',
    5: 'col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5',
    6: 'col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6',
    7: 'col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 col-xxl-7',
    8: 'col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8',
    9: 'col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9',
    10: 'col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-10',
    11: 'col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 col-xxl-11',
    12: 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'
  };

  constructor(
    private reportsService: ReportsService,
    private activeRoute: ActivatedRoute,
    private toastr: ToastrService,
    private inbuiltUtilityService: InbuiltUtilityService,
    private ngZone: NgZone,
    private sanitizer: DomSanitizer,
    private titleCase: TitleCasePipe,
    private dialog: MatDialog,
    private sharedAuthService: SharedAuthService
  ) { }

  private get resolvedReportName(): string {
    return this.reportNameFromInput || this.reportNameFromQueryParams || '';
  }


  ngOnInit(): void {
    this.activeRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.reportNameFromQueryParams = params['ReportName'] || ''; //get report name
      if (this.resolvedReportName) {
        this.initialiseData();//initialise data based on report name
      }
    });

    this.inbuiltUtilityService.getRefreshChildDataEvents()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.currentPage && this.currentTab) {
          // destroy all widgets so they re-initialize with fresh config
          this.isChildReportDataLoaded = false;
          this.onJsonEditorToggleChange(false);
          this.searchTriggered = false;
          const tabIdx = this.currentPage.tabs?.findIndex(t => t.key === this.currentTab!.key) ?? null;
          // defer to next tick so Angular processes the false state and tears down children first
          setTimeout(() => {
            this.getChildJSON(this.currentPage!, this.currentTab, tabIdx !== -1 ? tabIdx : null);
          }, 0);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reportNameFromInput'] && !changes['reportNameFromInput'].firstChange) {
      this.initialiseData();
    }
  }


  ngAfterViewInit(): void {
    this.widgetHosts.changes
      .pipe(startWith(this.widgetHosts), takeUntil(this.destroy$))
      .subscribe(() => {
        this.clearWidgetHeights();
        this.rebindResizeObservers();
        this.scheduleStabilizedRowSync();
      });

    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'resize')
        .pipe(auditTime(120), takeUntil(this.destroy$))
        .subscribe(() => {
          this.scheduleRowHeightSync();
        });
    });
  }

  initialiseData() {
    this.setDefaultData();
    this.showDefaultLoader();
    this.getParentJSON();
    const groups:any = JSON.parse(sessionStorage.getItem('secureGroups'));
    this.selectedSecure = Object.keys(groups).filter(item => groups[item] === 'Yes');
    this.hasReportAdminRole = this.sharedAuthService.getTohPageAccessDetails('Reports','Report_admin','edit');
  }

  refreshToggle(){
    this.onJsonEditorToggleChange(false);
  }

  // Fired once the "Select data source" modal persists its config - reload the report JSON so
  // dataSourceJson/hasDataSource reflect what was just saved.
  onDataSourceSaved(): void {
    this.setDefaultData();
    this.showDefaultLoader();
    this.getParentJSON();
  }

  showDefaultLoader() {
    const intervalId = setInterval(() => {
      if (this.isParentReportDataLoaded) {
        if (this.isChildReportDataLoaded) {
          this.clearLoaderInterval(intervalId);
        }
      }
    }, 500);

    //clear the interval after 5 seconds to avoid infinite loop in case spinner is not found
    setTimeout(() => {
      this.clearLoaderInterval(intervalId);
    }, 5000);
  }

  clearLoaderInterval(intervalId: any) {
    this.showView = true;
    if (intervalId) {
      clearInterval(intervalId);
    }
  }

  //Get selected tab data for filters
  getParentJSON() {
    this.reportsService.getInbuiltReport(this.resolvedReportName).subscribe((data) => {
      this.handleParentJSONData(data);
    }),
      (error: any) => {
        console.error('Error fetching report data: ', error);
      };
  }

   private isSecureRestricted(report: any): boolean {
    return report?.Access_Restricted === 'Yes' && report?.['Secure'] === 'Yes';
  }

  private getMatchedSecureGroups(report: any): any[] {
    const raw = report?.['Secure_Check'];
    if (!raw) return [];
    const list = raw.split(',');
    return list.filter((item: any) => this.selectedSecure.includes(item));
  }

  hasPageAccess(Report: any) {
    if (!this.isSecureRestricted(Report)) {
      return true ;
    }
    if(this.hasReportAdminRole) {
      return true;
    }

    const reportSecure = this.getMatchedSecureGroups(Report);
    if(reportSecure.length > 0) {
      return true;
    }else{
      return false;
    }

  }

  handleParentJSONData(data: any) {
    try {
      if (data && data.length > 0) {
        const report = data[0];
        this.hasPageAccessRole = this.hasPageAccess(report);
        this.reportDocumentation = report.Documentation || '';
        this.dataSourceJson = report.dataSourceJson ? JSON.parse(report.dataSourceJson) : {};
        let inbuiltReportData = report.inbuilt_report_json ? JSON.parse(report.inbuilt_report_json) : null;
        const parentJSON = JSON.parse(JSON.stringify(inbuiltReportData));
        
        this.parentJSON = {
          id: report.id || null,
          parent_json: parentJSON || {},
        }
        if (inbuiltReportData && inbuiltReportData.pages) {
          this.isParentReportDataLoaded = true;
          const keys = Object.keys(inbuiltReportData.pages);
          const pagesData: InbuiltReportModel = {
            pages: keys.map((key) => {
              return {
                key: key,
                name: inbuiltReportData.pages[key].name || key,
                order: inbuiltReportData.pages[key].order,
                tabs: inbuiltReportData.pages[key].tabs,
              };
            })
          };
          //sort pages data based on order
          // pagesData.pages.sort((a, b) => a.order - b.order);
          if (pagesData.pages && pagesData.pages.length > 0) {
            pagesData.pages.forEach((page) => {
              if (page.tabs) {
                const tabKeys = Object.keys(page.tabs);
                const sourceTabs = page.tabs as Record<string, any>;
                page.tabs = tabKeys.map((key:string) => {
                  return {
                    key,
                    name: sourceTabs[key]?.name || key,
                    order: sourceTabs[key]?.order,
                    elements: sourceTabs[key]?.elements,
                    documentation: '',
                    class: sourceTabs[key]?.class || '',
                  };
                });
              }
            });
            // set default page as first page in the list
            const index = Object.keys(inbuiltReportData.pages).findIndex(key => key === 'default');
            const currentPage: PageModel | null = pagesData.pages.length > 0 ? pagesData.pages[0] : null;
            const currentTab: TabModel | null = currentPage && currentPage.tabs && currentPage.tabs.length > 0 ? currentPage.tabs[0] : null;
            this.pages = pagesData.pages;
            if (currentPage) {
              this.getChildJSON(currentPage as PageModel, currentTab);
            }
          }
          
        }
      }else{
        this.toastr.error('No data found for the selected report.', 'Error', {
          timeOut: 5000,
        });
       this.showView = true;
      }
    } catch (error) {
      console.error('Error handling in parentJson data: ', error);
    }
  }

  getChildJSON(currentPage: PageModel, currentTab: TabModel | null, tabIndex: number | null = null) {
    // const pageIndex = this.pages.findIndex(page => page.key === currentPage.key);
    // if (pageIndex !== -1) {
    //   const tabPosition = currentTab && this.pages[pageIndex].tabs ? this.pages[pageIndex].tabs.findIndex(tab => tab.key === currentTab.key) : null;
    //   if (tabPosition != null && pageIndex != -1) {
    //     const allElementsFetched = this.pages[pageIndex].tabs[tabPosition].elements.every(ele => ele.isDataFetched === true);
    //     if (allElementsFetched) {
    //       this.getPageConfig();
    //       return;
    //     }
    //   }
    // }
    
    const payload = {
      report: this.resolvedReportName,
      page: currentPage ? currentPage.key : '',
      tab: currentTab ? currentTab.key : '',
    }
         this.reportsService.getInbuiltChildReport(payload).subscribe({
          next: (data) => {
            this.noElementsForTab = !data || data.length === 0;
            this.patchParentAndChildJson(data, currentPage, currentTab, tabIndex);
            this.isChildReportDataLoaded = true;
            this.isPageChanging = false;
            this.getPageConfig();
          },
          error: (error: any) => {
            this.isPageChanging = false;
            console.error('Error fetching report data: ', error);
          }
        });
  }

  patchParentAndChildJson(data: any, currentPage: PageModel, currentTab: TabModel | null, tabIndex: number | null) {
    try {
      if (data && data.length > 0) {
        this.patchPageElementsFromResponse(data, currentPage, currentTab);
      }
      this.resolveCurrentPageAndTab(currentPage, currentTab, tabIndex);
      if (data && data.length > 0 && currentPage && currentTab && tabIndex != null) {
        this.cacheCurrentPageAndTab();
      }
      
      this.checkIfFilterElementExists();
      // replace array reference so ngFor detects updated element objects
      this.pages = [...this.pages];
    } catch (error) {
      console.error('Error converting parent JSON data: ', error);
    }
  }

  private patchPageElementsFromResponse(data: any, currentPage: PageModel, currentTab: TabModel | null) {
    const pageIndex = this.pages.findIndex(page => page.key === currentPage.key);
    if (pageIndex === -1) {
      return;
    }
    // position of currentTab within this page's tabs (independent of the outer tabIndex param)
    const tabPosition = currentTab && this.pages[pageIndex].tabs
      ? this.pages[pageIndex].tabs.findIndex(tab => tab.key === currentTab.key)
      : null;
    if (tabPosition == null || tabPosition === -1) {
      return;
    }
    const elements = this.pages[pageIndex].tabs[tabPosition].elements;
    elements.forEach((element: any, index: number) => {
      this.patchSingleElement(element, index, elements, data, currentPage, currentTab);
    });
    const headerIndex = elements.findIndex(el => el.type == 'header');
    if(headerIndex !== -1) {
      //sort the children data
      const headerElement:any = elements[headerIndex];
      if (headerElement.children && headerElement.children.length > 0) {
        headerElement.children.sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0));
      }
    }
    elements.sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0));
  }

  private patchSingleElement(element: any, index: number, elements: any[], data: any, currentPage: PageModel, currentTab: TabModel | null) {
    element.type = element.type ? element.type.toLowerCase() : '';
    if (element.type == 'header') {
      this.updateHeaderChildLinks(element, data);
    }
    const elementDataIndex = data.findIndex((d: any) =>
      d.element_name === element.name &&
      d.element_type.toLowerCase() === element.type &&
      d.Page_name === currentPage.key &&
      d.tab_name === currentTab?.key
    );
    if (elementDataIndex === -1) {
      return;
    }
    elements[index] = this.buildPatchedElement(element, data[elementDataIndex]);
  }

  private updateHeaderChildLinks(element: any, data: any) {
    if (!element.children || element.children.length === 0) {
      return;
    }
    element.children.forEach((child: any) => {
      const childDataIndex = data.findIndex((d: any) => d.element_name === child.name && d.element_type === child.type);
      if (childDataIndex === -1) {
        return;
      }
      //check navigation link and values link in child data and update it in parent data
      const child_json = data[childDataIndex].element_json;
      child.element_json = child_json || {};
      child.element_id = data[childDataIndex].Id || null;
      child.Constructed_Query = data[childDataIndex].Constructed_Query || '';
      if (child_json.navigationLink) {
        element.navigationLink = child_json.navigationLink;
      }
    });
  }

  private buildPatchedElement(element: any, elementData: any): any {
    const parentConfig = element.config || {};
    const element_json = elementData.element_json;
    const rawFields: any[] = element_json?.fields || [];
    const fields = rawFields.length > 0
      ? rawFields.filter((f: any) => f.visibility === true).sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
      : [];
    if (fields.length > 0) {
      fields.forEach((field: any) => this.normalizeFieldDefaults(field));
    }
    return {
      fields: fields,
      name: elementData.element_name,
      type: elementData.element_type,
      order: element.order || 0,
      filterList: this.pluckJsonValue(element_json, 'applied_filter', []),
      config: this.pluckJsonValue(element_json, 'config', {}),
      no_filters: this.pluckJsonValue(element_json, 'no_filter', false),
      conditions: this.pluckJsonValue(element_json, 'conditions', ''),
      defaultQuery: this.pluckJsonValue(element_json, 'defaultQuery', ''),
      baseWhere: this.pluckJsonValue(element_json, 'baseWhere', ''),
      class: element.class || '',
      isAttributeVisibile: this.pluckJsonValue(element_json, 'isAttributeVisibile', false),
      defaultAttributeSelection: this.pluckJsonValue(element_json, 'defaultAttributeSelection', []),
      applied_filter: this.pluckJsonValue(element_json, 'applied_filter', []),
      valuesLink: this.pluckJsonValue(element_json, 'valuesLink', {}),
      navigationLink: this.pluckJsonValue(element_json, 'navigationLink', {}),
      parentConfig: parentConfig || {},
      element_json: JSON.parse(JSON.stringify(element_json)) || {},
      element_id: elementData.Id || null,
      Constructed_Query: elementData.Constructed_Query || '',
    };
  }

  private pluckJsonValue(element_json: any, key: string, fallback: any): any {
    return element_json ? (element_json[key] || fallback) : fallback;
  }

  private normalizeFieldDefaults(field: any) {
    field.type = field.type ? field.type.toLowerCase() : '';
    field.search = field.search ? field.search.toLowerCase() : '';
    const isNoneOrAll = field.default_selection &&
      (field.default_selection.toLowerCase() === 'none' || field.default_selection.toLowerCase() === 'all');
    field.default_selection = isNoneOrAll ? this.titleCase.transform(field.default_selection) : field.default_selection;
  }

  private resolveCurrentPageAndTab(currentPage: PageModel, currentTab: TabModel | null, tabIndex: number | null) {
    //FindPage with default key and set it as current page
    if (tabIndex == null) {
      const defaultPageIndex = this.pages.findIndex(page => page.key === 'default');
      this.currentPage = defaultPageIndex !== -1 ? this.pages[defaultPageIndex] : this.pages[0];
      this.currentTab = this.currentPage?.tabs && this.currentPage.tabs.length > 0 ? this.currentPage.tabs[0] : null;
    } else {
      // re-point currentPage to the live pages[] entry so its mutated elements are visible
      const resolved = this.pages.find(p => p.key === currentPage.key);
      if (resolved) this.currentPage = resolved;
      this.currentTab = this.currentPage?.tabs && this.currentPage.tabs.length > 0 ? this.currentPage.tabs[tabIndex] : null;
    }
  }

  private cacheCurrentPageAndTab() {
    const cachekey = `${this.resolvedReportName}_${this.currentPage ? this.currentPage.key : ''}_${this.currentTab ? this.currentTab.key : ''}_data_page`;
    const object = {
      currentPage: this.currentPage,
    };
    const tabCacheKey = `${this.resolvedReportName}_${this.currentPage ? this.currentPage.key : ''}_${this.currentTab ? this.currentTab.key : ''}_data_tab`;
    const tabObject = {
      currentTab: this.currentTab,
    };
    this.inbuiltUtilityService.cacheData(tabCacheKey, tabObject);
    this.inbuiltUtilityService.cacheData(cachekey, object);
  }

  checkTabLabelEmpty() {
    if(this.currentPage && this.currentPage?.tabs.length  == 1 && this.currentPage?.tabs[0].name.trim() === 'default') {
      this.isTabLabelEmpty = true;
    }else{
      this.isTabLabelEmpty = false;
    }
  }

  checkIfFilterElementExists() {
    this.searchTriggered = false;
    const isExists = this.currentTab?.elements.some(ele => ele.type === 'filter');
    if(!isExists){
      this.searchTriggered = true;
    }
  }

  setDefaultData() {
    this.currentPage = null;
    this.isCurrentPageDataLoaded = false;
    this.isParentReportDataLoaded = false;
    this.isChildReportDataLoaded = false;
  }

  handleErrors(error: any) {
    console.error('Error: ', error);
    this.toastr.error('An error occurred while fetching data. Please try again later.', 'Error', {
      timeOut: 5000,
    });
  }

  

  onPageChange(page: PageModel, tabIndex: number | null = null) {
    // reference the live pages[] entry so mutations from patchParentAndChildJson are visible on this.currentPage
    this.currentPage = this.pages.find(p => p.key === page.key) ?? page;
    this.currentTab = this.currentPage?.tabs ? this.currentPage.tabs[tabIndex ?? 0] : null;

    const cachekey = `${this.resolvedReportName}_${this.currentPage?.key ?? ''}_${this.currentTab?.key ?? ''}_data_page`;
    const cached = this.inbuiltUtilityService.getCachedData(cachekey);
    this.onJsonEditorToggleChange(false);
    if (cached && cached.currentPage && cached.currentPage.tabs) {
      // destroy then recreate widget-elements-row so child components reinit with the cached page's data
      this.noElementsForTab = !!cached.noElementsForTab;
      this.isPageChanging = true;
      this.getPageConfig();
      this.checkTabLabelEmpty();
      this.checkIfFilterElementExists();
      setTimeout(() => { this.isPageChanging = false; }, 0);
    } else {
      // set loader before any render so it always appears on cache miss
      this.isPageChanging = true;
      this.getChildJSON(this.currentPage!, this.currentTab, 0);
    }
  }

  onTabChange(tab: any) {
    this.onJsonEditorToggleChange(false);
    const tabIndex = tab.index;
    const currentTab = this.currentPage?.tabs ? this.currentPage.tabs[tabIndex] : null;
    
    const cachekey = `${this.resolvedReportName}_${this.currentPage ? this.currentPage.key : ''}_${currentTab ? currentTab.key : ''}_data_page`;
    const object = this.inbuiltUtilityService.getCachedData(cachekey);
    if(object && object.currentPage && object.currentPage.tabs){
      this.noElementsForTab = !!object.noElementsForTab;
      this.currentTab = this.currentPage?.tabs ? this.currentPage.tabs[tab.index] : null;
      this.getPageConfig();
      this.checkTabLabelEmpty();
      this.checkIfFilterElementExists();
    }else{
      this.getChildJSON(this.currentPage!, currentTab, tabIndex);
    }
  }

  getPageConfig(){
    this.pageConfig = {
      currentPage: this.currentPage,
      currentTab: this.currentTab,
      reportNameFromQueryParams: this.resolvedReportName,
      parentJSON: this.parentJSON
    }
    this.tableConfig = {
      ...this.pageConfig,
    }
  }

  handleTableAttribute(ev: any){
    this.searchTriggered = ev?.showTable === true;
    this.tableConfig = {
      ...this.pageConfig,
      ...ev
    }
  }


  updatePageDataFromChildComponents(ev: any){
    if(ev && ev.page && ev.tab && ev.element){
      const pageIndex = this.pages.findIndex(page => page.key === ev.page.key);
      if(pageIndex !== -1){
        const tabIndex = this.pages[pageIndex].tabs.findIndex(tab => tab.key === ev.tab.key);
        if(tabIndex !== -1){
          const elementIndex = this.pages[pageIndex].tabs[tabIndex].elements.findIndex(ele => ele.name === ev.element.name);
          if(elementIndex !== -1){
            this.pages[pageIndex].tabs[tabIndex].elements[elementIndex] = ev.data;
          }
        }
      }
    }
  }

  //Navigate to documentation page
  info() {
    if(this.reportDocumentation){
      window.open(this.reportDocumentation, '_blank');
    }
  }



  /**
 * Sets the side navigation theme.
 * @param theme The theme to set ('theme1' or 'theme2').
 */
setSideNavTheme(theme: 'theme1' | 'theme2'): void {
  this.sideNavTheme = theme;
}
/**
 * Toggles the side menu expanded/collapsed state.
 */
toggleSideMenu(): void {
  this.sideMenuExpanded = !this.sideMenuExpanded;
}
/**
 * Returns the nodes for the side menu, memoized for performance.
 */
private _sideMenuNodesCache: {pages: any, nodes: SideMenuNode[]} = {pages: null, nodes: []};
get sideMenuNodes(): SideMenuNode[] {
  if (this._sideMenuNodesCache.pages === this.pages) return this._sideMenuNodesCache.nodes;
  if (!this.pages?.length) return [];
  const normKey = (v: string) => (v || '').trim().toLowerCase();
  // "default" pages/tabs are still shown (not hidden); their label falls back to the report name instead of the literal key.
  const displayName = (key: string, name: string) => normKey(key) === 'default' ? this.titleCase.transform(this.resolvedReportName) : name;
  // Always keep the page node (even for a single "default" page) so its name/report-name label stays visible above its tabs.
  const nodes: SideMenuNode[] = this.pages.map(page => ({
    id: page.key,
    type: 'page',
    name: displayName(page.key, page.name),
    // Lets the side menu know it hid a "default" tab, since such pages have no visible children to infer this from.
    metadata: { pageKey: page.key, hasHiddenDefaultTab: (page.tabs || []).length === 1 && normKey(page.tabs[0].key) === 'default' },
    children: (page.tabs || [])
      .filter(tab => normKey(tab.key) !== 'default')
      .map(tab => ({
        id: `${page.key}__${tab.key}`,
        type: 'tab',
        name: tab.name,
        metadata: { pageKey: page.key, tabKey: tab.key }
      }))
  }));
  this._sideMenuNodesCache = {pages: this.pages, nodes};
  return nodes;
}
/**
 * Handles selection of a node in the side menu.
 * Logs an error if an unexpected node type is encountered.
 */
onSideMenuNodeSelect(event: SideMenuSelectEvent): void {
  console.log('Side menu node select event:', event);
  if (!event?.node) return;
  const { node } = event;
  if (node.markedForDeletion) {
    this.selectedNodeUnavailable = true;
    this.unavailableNodeName = node.name;
    return;
  }
  this.selectedNodeUnavailable = false;
  const pageKey: string = node.metadata?.['pageKey'];
  const tabKey: string = node.metadata?.['tabKey'];
  const page = this.pages.find(p => p.key === pageKey);
  if (!page) return;
  if (node.type === 'page') {
    // Pages with real (non-"default") tab children are containers in the tree - the sidemenu already
    // expands/collapses them on click, so just let that happen without loading page data; a page with
    // no visible children (only the hidden "default" tab) is a leaf and should load its data directly.
    if (node.children?.length) {
      return;
    }
    this.onPageChange(page);
  } else if (node.type === 'tab') {
    const tabIndex = page.tabs.findIndex(t => t.key === tabKey);
    const tab = tabIndex >= 0 ? page.tabs[tabIndex] : null;
    if (tab) {
      this.onSideMenuTabChange({ page, tab, tabIndex });
    }
  } else {
    console.error('Unknown node type in sidemenu:', node);
  }
}

/**
 * Handles the Save action from the side menu editor (add/rename/delete page & tab nodes).
 * Builds the updated report json plus the list of deleted pages/tabs (id + name), then persists it.
 */
onSideMenuSave(nodes: SideMenuNode[]): void {
  const { updatedPages, updatedTabs, deletedPages, deletedTabs, addedPages, addedTabs } = this.diffSideMenuNodes(nodes);
  const updatedJson = this.buildParentJsonFromPages(updatedPages);

  if (!deletedPages.length && !deletedTabs.length && !addedPages.length && !addedTabs.length && !updatedTabs.length) {
    return;
  }

  const reportId = this.parentJSON?.id ?? null;
  if (reportId == null) {
    this.pages = updatedPages;
    return;
  }

  const payload = {
    Report: this.resolvedReportName,
    Report_Type: 'inBuilt',
    id: reportId,
    inbuilt_report_json: JSON.stringify(updatedJson),
    delete_pages: deletedPages.length > 0 ? deletedPages.map(p => ({ page_name: p.id })) : [],
    delete_tabs: deletedTabs.length > 0 ? deletedTabs.map(t => ({ page_name: t.page_name, tab_name: t.id })) : [],
  };
  this.reportsService.updateReportPagesOrTabs(payload).subscribe({
    next: (_res: any) => {
      this.toastr.success('Report structure updated successfully', '', {
        timeOut: 3000,
        positionClass: 'toast-top-center'
      });
      this.onJsonEditorToggleChange(false);
      this.setDefaultData();
      this.showDefaultLoader();
      this.getParentJSON();
    },
    error: (_err: any) => {
      this.toastr.error('Error updating report structure', '', {
        timeOut: 3000,
        positionClass: 'toast-top-center'
      });
    }
  });
}

/**
 * Compares the edited side menu tree against `this.pages` to find added/removed pages & tabs,
 * and rebuilds a full PageModel[] (preserving existing tab elements/order for untouched tabs).
 * Deleted pages/tabs are reported as `{ id, name }` (id = the page/tab key).
 */
private diffSideMenuNodes(nodes: SideMenuNode[]): {
  updatedPages: PageModel[];
  updatedTabs: { page: string; tab: string }[];
  deletedPages: { id: string; name: string }[];
  deletedTabs: { id: string; name: string ,page_name: string }[];
  addedPages: string[];
  addedTabs: { page: string; tab: string }[];
} {
  const pageNodes = nodes.filter(n => n.type === 'page');
  const deletedPages: { id: string; name: string }[] = [];
  const deletedTabs: { id: string; name: string ,page_name: string }[] = [];
  const addedPages: string[] = [];
  const addedTabs: { page: string; tab: string }[] = [];
  const updatedTabs: { page: string; tab: string }[] = [];
  const normKey = (v: string) => (v || '').trim().toLowerCase();
  this.pages.forEach(page => {
    if (!pageNodes.some(n => n.metadata?.['pageKey'] === page.key)) {
      deletedPages.push({ id: page.key, name: page.name });
    }
  });

  const updatedPages: PageModel[] = pageNodes.map((pageNode, pageIdx) => {
    const pageKey = pageNode.metadata?.['pageKey'] || pageNode.id;
    const existingPage = this.pages.find(p => p.key === pageKey);
    if (!existingPage) {
      addedPages.push(pageNode.name);
    }
    const pageNameForLog = pageNode.name || existingPage?.name || pageKey;
    const tabNodes = pageNode.children || [];
    // "default" tabs are never shown in the sidemenu tree, so they never appear in tabNodes -
    // skip them here and re-append them untouched below, instead of treating them as deleted.
    const existingNonDefaultTabs = (existingPage?.tabs || []).filter(tab => normKey(tab.key) !== 'default');
    const existingDefaultTabs = (existingPage?.tabs || []).filter(tab => normKey(tab.key) === 'default');

    if (existingPage) {
      existingNonDefaultTabs.forEach(tab => {
        if (!tabNodes.some(t => t.metadata?.['tabKey'] === tab.key)) {
          deletedTabs.push({ id: tab.key, name: tab.name , page_name: pageNameForLog });
        }
      });
    }

    const tabs: TabModel[] = tabNodes.map((tabNode, tabIdx) => {
      const tabKey = tabNode.metadata?.['tabKey'] || tabNode.id;
      const existingTab: any = existingPage?.tabs?.find(t => t.key === tabKey);
      if (!existingTab) {
        addedTabs.push({ page: pageNameForLog, tab: tabNode.name });
      } else {
        updatedTabs.push({ page: pageNameForLog, tab: tabNode.name });
      }
      return {
        key: tabKey,
        name: tabNode.name,
        order: existingTab?.order ?? (tabIdx + 1),
        elements: existingTab?.elements ?? [],
        documentation: existingTab?.documentation ?? '',
        class: existingTab?.class ?? ''
      } as TabModel;
    });
    // Carry the hidden "default" tab(s) over untouched - they're never editable via the sidemenu tree.
    tabs.push(...(existingDefaultTabs as TabModel[]));

    return {
      key: pageKey,
      name: pageNode.name,
      order: existingPage?.order ?? (pageIdx + 1),
      tabs
    } as PageModel;
  });

  return { updatedPages, updatedTabs, deletedPages, deletedTabs, addedPages, addedTabs };
}

/** Rebuilds just the `{ pages: { [key]: { name, order, tabs: { [key]: { name, order, elements } } } } }` shape - no other report-level keys. */
private buildParentJsonFromPages(pages: PageModel[]): any {
  const pagesObj: any = {};
  pages.forEach(page => {
    const tabsObj: any = {};
    (page.tabs || []).forEach((tab: any) => {
      const tabEntry: any = {
        name: tab.name,
        order: tab.order,
        // Strip the UI-only fields (fields/config/filterList/etc.) patched onto elements for rendering - persist only these 4 keys.
        elements: (tab.elements || []).map((el: any) => ({
          name: el.name,
          type: el.type,
          order: el.order,
          class: el.class
        }))
      };
      if (tab.class) {
        tabEntry.class = tab.class;
      }
      tabsObj[tab.key] = tabEntry;
    });
    pagesObj[page.key] = {
      name: page.name,
      order: page.order,
      tabs: tabsObj
    };
  });
  return { pages: pagesObj };
}

  shouldShowSideNav(): boolean {
    if (!this.pages || this.pages.length === 0) return false;
    if (this.pages.length === 1) {
      const pk = (this.pages[0]?.key || '').trim().toLowerCase();
      if (pk === 'default') {
        const tabs = this.pages[0]?.tabs || [];
        if (tabs.length === 1) {
          const tk = (tabs[0]?.key || '').trim().toLowerCase();
          if (tk === 'default') return false;
        }
      }
    }
    return true;
  }

  getContentColClass(): string {
    if (this.sideNavTheme !== 'theme2' || !this.shouldShowSideNav()) {
      return 'col-12';
    }
    return 'content-col-theme2';
  }

  onSideMenuTabChange(event: { page: PageModel; tab: TabModel; tabIndex: number }): void {
    if (!event?.page || !event?.tab) return;
    this.isTabLabelEmpty = false;
    this.searchTriggered = false;
    this.currentPage = event.page;
    const cachekey = `${this.resolvedReportName}_${event.page.key}_${event.tab.key}_data_page`;
    const cached = this.inbuiltUtilityService.getCachedData(cachekey);
    if (cached && cached.currentPage && cached.currentPage.tabs) {
      this.noElementsForTab = !!cached.noElementsForTab;
      this.currentTab = this.currentPage?.tabs?.[event.tabIndex] ?? event.tab;
      this.getPageConfig();
      this.checkTabLabelEmpty();
      this.checkIfFilterElementExists();
    } else {
      this.getChildJSON(event.page, event.tab, event.tabIndex);
    }
  }

  getSelectedTabIndex(): number {
    if (!this.currentPage?.tabs?.length || !this.currentTab) return 0;
    const idx = this.currentPage.tabs.findIndex(t => t.key === this.currentTab!.key);
    return idx >= 0 ? idx : 0;
  }

  getElementLayoutClass(element: any, tab: any): string {
    const classValue = element?.class ?? tab?.class;
    return this.resolveResponsiveColClass(classValue);
  }

  shouldAddRowStartPadding(element: any, tab: any, elementIndex: number, elements: any[]): boolean {
    if (!Array.isArray(elements) || elementIndex < 0 || elementIndex >= elements.length) {
      return false;
    }

    const currentSpan = this.resolveElementSpan(elements[elementIndex], tab);
    if (currentSpan >= 12) {
      return false;
    }

    let occupiedInRow = 0;
    for (let i = 0; i <= elementIndex; i++) {
      const span = this.resolveElementSpan(elements[i], tab);

      if (span >= 12) {
        if (i === elementIndex) {
          return false;
        }
        occupiedInRow = 0;
        continue;
      }

      if (occupiedInRow + span > 12) {
        occupiedInRow = 0;
      }

      const isFirstInRenderedRow = occupiedInRow === 0;
      if (i === elementIndex) {
        return !isFirstInRenderedRow;
      }

      occupiedInRow += span;
      if (occupiedInRow >= 12) {
        occupiedInRow = 0;
      }
    }

    return false;
  }

  private resolveElementSpan(element: any, tab: any): number {
    const classValue = element?.class ?? tab?.class;

    if (typeof classValue === 'number' && classValue >= 1 && classValue <= 12) {
      return classValue;
    }

    const trimmed = String(classValue ?? '').trim();
    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric) && numeric >= 1 && numeric <= 12) {
      return numeric;
    }

    const responsiveMatch = trimmed.match(/col-(?:md|lg|xl|xxl)-(\d{1,2})/);
    if (responsiveMatch) {
      const responsiveSpan = Number(responsiveMatch[1]);
      if (!Number.isNaN(responsiveSpan) && responsiveSpan >= 1 && responsiveSpan <= 12) {
        return responsiveSpan;
      }
    }

    const baseMatch = trimmed.match(/col-(\d{1,2})/);
    if (baseMatch) {
      const baseSpan = Number(baseMatch[1]);
      if (!Number.isNaN(baseSpan) && baseSpan >= 1 && baseSpan <= 12) {
        return baseSpan;
      }
    }

    return 12;
  }

  trackByTab(_index: number, tab: any): string {
    // page key prefix ensures mat-tabs are recreated when the active page changes
    const pageKey = this.currentPage?.key ?? '';
    return `${pageKey}__${tab?.key ?? String(_index)}`;
  }

  trackByElement(_index: number, element: any): string {
    // page+tab prefix recreates components on page change; same page reuses DOM to avoid the ngFor warning
    const pageKey = this.currentPage?.key ?? '';
    const tabKey = this.currentTab?.key ?? '';
    return `${pageKey}__${tabKey}__${element?.name ?? String(_index)}__${element?.type ?? ''}`;
  }

  getElementWrapperTitle(element: any): string {
    //if starts with { bracket then show display name else show name
    let title = '';
    if (element?.name && String(element.name).trim().startsWith('{')) {
      title = element?.display_name || '';
    }else{
      title = element?.name || '';
    }
   

    return String(title).trim();
  }

  private resolveResponsiveColClass(classValue: any): string {
    if (classValue === null || classValue === undefined || classValue === '') {
      return 'col-12';
    }

    if (typeof classValue === 'number' && this.responsiveColClassMap[classValue]) {
      return this.responsiveColClassMap[classValue];
    }

    const numericClass = Number(String(classValue).trim());
    if (!Number.isNaN(numericClass) && this.responsiveColClassMap[numericClass]) {
      return this.responsiveColClassMap[numericClass];
    }

    if (typeof classValue === 'string' && classValue.trim()) {
      return classValue.trim();
    }

    return 'col-12';
  }

  private rebindResizeObservers(): void {
    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    if (!this.resizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.isApplyingRowHeights) {
          return;
        }
        this.scheduleRowHeightSync();
      });
    }

    this.resizeObserver.disconnect();
    this.widgetHosts?.forEach((ref: ElementRef<HTMLElement>) => {
      const native = ref?.nativeElement;
      if (native) {
        const observeTarget = (native.firstElementChild as HTMLElement | null) || native;
        this.resizeObserver?.observe(observeTarget);
      }
    });
  }

  private scheduleStabilizedRowSync(): void {
    this.scheduleRowHeightSync();
    this.scheduleRowHeightSync(120);
    this.scheduleRowHeightSync(320);
    this.scheduleRowHeightSync(700);
  }

  private scheduleRowHeightSync(delayMs: number = 0): void {
    if (delayMs > 0) {
      window.setTimeout(() => this.scheduleRowHeightSync(), delayMs);
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      if (this.resizeRafId !== null) {
        cancelAnimationFrame(this.resizeRafId);
      }

      this.resizeRafId = requestAnimationFrame(() => {
        this.resizeRafId = null;
        this.applyEqualHeightsPerRenderedRow();
      });
    });
  }

  private applyEqualHeightsPerRenderedRow(): void {
    const allHosts = (this.widgetHosts?.toArray() || [])
      .map((ref: ElementRef<HTMLElement>) => ref.nativeElement)
      .filter((node: HTMLElement | null) => !!node && node.isConnected) as HTMLElement[];

    if (allHosts.length === 0) {
      return;
    }

    allHosts.forEach((node: HTMLElement) => node.classList.remove('pe-0'));
    this.clearWidgetHeights(allHosts);

    const activeHosts = allHosts.filter((node: HTMLElement) => {
      const rect = node.getBoundingClientRect();
      return rect.width > 0 && this.measureWidgetHeight(node) > 0;
    });

    if (activeHosts.length === 0) {
      this.clearWidgetHeights(allHosts);
      return;
    }

    this.isApplyingRowHeights = true;
    try {
      const rows = new Map<number, HTMLElement[]>();
      activeHosts.forEach((node: HTMLElement) => {
        const top = Math.round(node.getBoundingClientRect().top);
        let matchedTop: number | null = null;
        rows.forEach((_nodes, rowTop) => {
          if (matchedTop === null && Math.abs(rowTop - top) <= this.rowTopTolerance) {
            matchedTop = rowTop;
          }
        });

        const bucketTop = matchedTop === null ? top : matchedTop;
        const rowNodes = rows.get(bucketTop) || [];
        rowNodes.push(node);
        rows.set(bucketTop, rowNodes);
      });

      rows.forEach((rowNodes: HTMLElement[]) => {
        const maxHeight = rowNodes.reduce((maxVal: number, node: HTMLElement) => {
          return Math.max(maxVal, this.measureWidgetHeight(node));
        }, 0);

        const lastNodeInRow = rowNodes.reduce((last: HTMLElement, current: HTMLElement) => {
          const lastRight = last.getBoundingClientRect().right;
          const currentRight = current.getBoundingClientRect().right;
          return currentRight > lastRight ? current : last;
        }, rowNodes[0]);

        rowNodes.forEach((node: HTMLElement) => {
          if (node !== lastNodeInRow) {
            node.classList.add('pe-0');
          }
        });

        if (maxHeight < this.meaningfulHeightPx) {
          return;
        }

        rowNodes.forEach((node: HTMLElement) => {
          node.style.minHeight = `${maxHeight}px`;
        });
      });
    } finally {
      this.isApplyingRowHeights = false;
    }
  }

  private measureWidgetHeight(node: HTMLElement): number {
    const hostRectHeight = Math.ceil(node.getBoundingClientRect().height);
    const hostScrollHeight = Math.ceil(node.scrollHeight || 0);
    const firstChild = node.firstElementChild as HTMLElement | null;
    const childRectHeight = firstChild ? Math.ceil(firstChild.getBoundingClientRect().height) : 0;
    const childScrollHeight = firstChild ? Math.ceil(firstChild.scrollHeight || 0) : 0;

    return Math.max(hostRectHeight, hostScrollHeight, childRectHeight, childScrollHeight, 0);
  }

  private clearWidgetHeights(nodes?: HTMLElement[]): void {
    const targets = nodes || (this.widgetHosts?.toArray() || []).map((ref: ElementRef<HTMLElement>) => ref.nativeElement);
    targets.forEach((node: HTMLElement) => {
      if (node) {
        node.style.minHeight = '';
        node.style.height = 'auto';
      }
    });
  }

  ngOnDestroy(): void {
    if (this.resizeRafId !== null) {
      cancelAnimationFrame(this.resizeRafId);
      this.resizeRafId = null;
    }

    this.resizeObserver?.disconnect();
    this.resizeObserver = null;

    this.destroy$.next();
    this.destroy$.complete();
    this.inbuiltUtilityService.clearAllCachedData();
    this.inbuiltUtilityService.clearJsonEditorToggleState();
  }

  navigateToPageOrExternalLink(navigationLink: any) {
    try {
      const obj = Object.keys(navigationLink);
      //validate the navigation is page level or internal level to other page or external level
      const isPageLevel = obj.includes('inReportLink');
      const isInternalLevel = obj.includes('PageLink');
      const isExternalLevel = obj.includes('ExternalLink');
      if (isPageLevel) {
        const pageName = navigationLink.inReportLink.pageName;
        const tabName = navigationLink.inReportLink.tabName;
        const pageIndex = this.pages.findIndex(page => page.key.toLowerCase() === pageName.toLowerCase());
        if (pageIndex !== -1) {
          const tabIndex = this.pages[pageIndex].tabs.findIndex(tab => tab.key.toLowerCase() === tabName.toLowerCase());
          if (tabIndex !== -1) {
            this.currentTab = this.pages[pageIndex].tabs[tabIndex];
            this.onPageChange(this.pages[pageIndex], tabIndex);
          }
        }
      } else if (isInternalLevel || isExternalLevel) {
        const rawLink = navigationLink.pageLink || navigationLink.externalLink;
        const resolvedBaseUrl = this.getBaseUrl();
        const resolvedPath = rawLink.replace(/\{base_url\}/gi, resolvedBaseUrl).trim();
        const params = navigationLink.pageLink?.params || navigationLink.externalLink?.params || {};
        const queryParams = this.buildLinkQueryParams(navigationLink.pageLink || navigationLink.externalLink, {}, '', '');
        const finalUrl = queryParams ? `${resolvedPath}?${queryParams}` : resolvedPath;
        const isNewTab = navigationLink.pageLink?.newBrowserTab || navigationLink.externalLink?.newBrowserTab;
        // Sanitize URL before navigation
        const safeUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(finalUrl);
        if (isNewTab) {
          window.open(String(safeUrl), '_blank');
        } else {
          window.location.href = String(safeUrl);
        }
      }
    } catch (error) {
      console.error('Error navigating to page or external link: ', error);
    }
  }


   private buildLinkQueryParams(linkConfig: any, rowData: any, columnKey: string, cellValue: any): string {
    const paramsConfig = typeof linkConfig === 'object' && linkConfig && !Array.isArray(linkConfig)
      ? (linkConfig.params || {})
      : {};

    const queryParts: string[] = [];
    const appendParam = (paramName: string, value: any) => {
      const cleanParamName = String(paramName ?? '').trim();
      if (!cleanParamName || value === null || value === undefined || value === '') {
        return;
      }

      queryParts.push(`${encodeURIComponent(cleanParamName)}=${encodeURIComponent(String(value))}`);
    };

    Object.keys(paramsConfig || {}).forEach((sourceKey: string) => {
      const targetParamName = paramsConfig[sourceKey];
      const rowValue = Object.prototype.hasOwnProperty.call(rowData || {}, sourceKey)
        ? rowData[sourceKey]
        : (sourceKey === columnKey ? cellValue : undefined);

      appendParam(targetParamName, rowValue);
    });

    return queryParts.join('&');
  }



  private getBaseUrl(): string {
    const fallbackBaseUrl = window?.location?.origin || '';
    return String(fallbackBaseUrl).replace(/\/$/, '');
  }

  onJsonEditorToggleChange(event: any) {
    this.showJsonEditor = event;
    this.inbuiltUtilityService.setJsonEditorToggleState(event);
  }

  openJSONeditorForParent() {
    this.isJSONeditorPopupOpen = true;
    this.modalEditJSON.show();
  }

  /** "Filter" segment of the Add Visual JSON menu — disabled once the tab already has filter JSON. */
  filterMenuItems: VisualMenuItem[] = [];

  /** "Visuals" segment — fixed list of chart/table/etc types; never disabled. */
  visualMenuItems: VisualMenuItem[] = [];

  /** Rebuilds filterMenuItems/visualMenuItems once instead of via a template getter, which would rebuild new
   *  array/object instances on every change-detection cycle and cause *ngFor to tear down and recreate the
   *  menu buttons out from under in-flight click events. */
  private refreshVisualMenuItems(): void {
    const items = this.buildVisualMenuItems();
    this.filterMenuItems = items.filter(item => item.type === 'filter');
    this.visualMenuItems = items.filter(item => item.type !== 'filter');
  }

  /** Toggles the "Add Visual JSON" menu, refreshing its items just before it opens. */
  toggleAddVisualMenu(): void {
    if (!this.showMenu) {
      this.refreshVisualMenuItems();
    }
    this.showMenu = !this.showMenu;
  }

  trackByVisualMenuItem(_index: number, item: VisualMenuItem): string {
    return item.type;
  }

  private buildVisualMenuItems(): VisualMenuItem[] {
    try {
      const items: VisualMenuItem[] = [];

      const filterAlreadyDefined = this.isElementTypeAlreadyDefined('filter');
      items.push({
        type: 'filter',
        name: 'Filter',
        icon: this.elementTypeIcons['filter'] || 'widgets',
        alreadyDefined: filterAlreadyDefined,
        tooltip: filterAlreadyDefined ? 'Filter JSON already present' : 'Add visual json'
      });

      this.visualElementTypes.forEach((el:any) => {
        const type = el.key;
        const name = el.value;
        items.push({
          type,
          name: type,
          icon: this.elementTypeIcons[type] || 'widgets',
          alreadyDefined: false,
          tooltip: name
        });
      });

      return items;
    } catch (e) {
      console.error('Error building visual menu items: ', e);
      return [];
    }
  }

  /** True when currentTab already has an element of this type with saved JSON (element_id or a non-empty element_json). */
  private isElementTypeAlreadyDefined(type: string): boolean {
    const elements = this.currentTab?.elements || [];
    return elements.some((el: any) => {
      if (String(el?.type ?? '').trim().toLowerCase() !== type) return false;
      const hasElementJson = !!el?.element_json && typeof el.element_json === 'object' && Object.keys(el.element_json).length > 0;
      return !!el?.element_id || hasElementJson;
    });
  }

  /** Closes the "Add Visual JSON" menu when clicking anywhere outside of it. */
  @HostListener('document:click', ['$event'])
  onDocumentClickCloseAddVisualMenu(event: MouseEvent): void {
    if (!this.showMenu) return;
    const container = this.addVisualMenuContainerRef?.nativeElement;
    if (container && !container.contains(event.target as Node)) {
      this.showMenu = false;
    }
  }

  openAddVisualJsonModal(type: string): void {
    // if (this.isElementTypeAlreadyDefined(type)) return;
    this.selectedVisualType = type;
    this.addVisualElementName = '';
    // Filter rank is always fixed at 1 and cannot be edited by the user.
    this.addVisualElementRank = type === 'filter' ? 1 : null;
    this.addVisualElementWidth = null;
    this.pendingRankConflict = false;
    const defaultTemplate = type === 'filter' ? FILTER_ELEMENT_DEFAULT_JSON : OTHER_ELEMENT_DEFAULT_JSON;
    this.addVisualJsonData = JSON.parse(JSON.stringify(defaultTemplate));
    this.isAddVisualJsonPopupOpen = true;
    this.modalAddVisualJSON?.show();
    this.showMenu = false;
  }

  /** Rank input is only editable for non-filter visual types; filter rank is always pinned to 1. */
  get isAddVisualRankDisabled(): boolean {
    return this.selectedVisualType === 'filter';
  }

  /** Clamps the width/class field to the supported 1-12 column range.
   *  Also force-syncs the native input's DOM value: Angular skips re-writing the view when the
   *  clamped model value equals what it already was (e.g. typing "3" after "12" makes "123", which
   *  clamps back down to the unchanged 12), so without this the input would keep showing "123". */
  onAddVisualWidthChange(input?: HTMLInputElement): void {
    if (this.addVisualElementWidth === null || this.addVisualElementWidth === undefined || (`${this.addVisualElementWidth}` as any) === '') {
      return;
    }
    const numeric = Number(this.addVisualElementWidth);
    if (Number.isNaN(numeric)) {
      this.addVisualElementWidth = null;
      return;
    }
    this.addVisualElementWidth = Math.min(12, Math.max(1, Math.trunc(numeric)));
    if (input) {
      input.value = String(this.addVisualElementWidth);
    }
  }

  /** Any rank edit invalidates a previously-shown collision warning so it re-evaluates against the new value. */
  onAddVisualRankChange(): void {
    this.pendingRankConflict = false;
  }

  get isAddVisualNameValid(): boolean {
    return !!this.addVisualElementName && this.addVisualElementName.trim().length > 0;
  }

  get isAddVisualRankValid(): boolean {
    const rank = this.addVisualElementRank;
    return rank !== null && rank !== undefined && Number.isInteger(Number(rank)) && Number(rank) >= 1;
  }

  get isAddVisualWidthValid(): boolean {
    const width = this.addVisualElementWidth;
    return width !== null && width !== undefined && Number.isInteger(Number(width)) && Number(width) >= 1 && Number(width) <= 12;
  }

  /** Element Name, Rank and Width are all mandatory; Save stays disabled until every one of them is valid. */
  get isAddVisualFormValid(): boolean {
    return this.isAddVisualNameValid && this.isAddVisualRankValid && this.isAddVisualWidthValid;
  }

  onDuplicateElementExistChange(ev: any): void {
    if (ev) {
      this.duplicateElementExist = '';
    }
  }

  

  findDuplicateElementByNameAndType(name: string, type: string): boolean {
    const elements = this.currentTab?.elements || [];
    return !!elements.find((el: any) => String(el?.name ?? '').trim() === String(name ?? '').trim() && String(el?.type ?? '').trim() === String(type ?? '').trim());
  }

  /** Existing element (if any) in the current tab already holding the requested rank; filter's fixed rank is excluded from this check. */
  private findAddVisualRankConflict(): any {
    const elements = this.currentTab?.elements || [];
    return elements.find((el: any) => Number(el?.order) === Number(this.addVisualElementRank)) || null;
  }

  onAddVisualJsonTextChange(ev: any): void {
    this.duplicateElementExist = '';
    const duplicateElement = this.findDuplicateElementByNameAndType(this.addVisualElementName, this.selectedVisualType);
    this.duplicateElementExist = duplicateElement ? this.addVisualElementName : '';
    if (this.duplicateElementExist) {
      return;
    }
    const pageKey = this.currentPage?.key ?? '';
    const tabKey = this.currentTab?.key ?? '';
    const cloned = JSON.parse(JSON.stringify(this.parentJSON?.parent_json || {}));
    const tab = cloned?.pages?.[pageKey]?.tabs?.[tabKey];
    const addVisualElementRank: number = Number(this.addVisualElementRank);
    if(this.selectedVisualType === 'filter') {
      if(tab.elements.length > 0) {
        tab.elements.forEach((el: any) => {
          if (el?.type !== 'filter') {
            el.order = Number(el.order) + 1;
          }
        });
      }
    }else{
      if(tab.elements.length > 0) {
        tab.elements.forEach((el: any) => {
          if (el?.type !== 'filter' && Number(el?.order) >= addVisualElementRank) {
            el.order = Number(el.order) + 1;
          }
        });
      }
    }

    const reportId = this.parentJSON?.id ?? null;
    const newElement = {
      name: this.addVisualElementName,
      type: this.selectedVisualType,
      order: addVisualElementRank,
      class: this.addVisualElementWidth
    };
    tab.elements.push(newElement);
    tab.elements.sort((a: any, b: any) => Number(a.order) - Number(b.order));
    const updatedParentJson = JSON.parse(JSON.stringify(this.parentJSON?.parent_json || {}));
    updatedParentJson.pages[pageKey].tabs[tabKey].elements = tab.elements;
    const payload = {
      report: this.resolvedReportName,
      Report_Type: 'inBuilt',
      parent_id: reportId,
      element_json: ev || {},
      Page_name: pageKey,
      tab_name: tabKey,
      element_order: this.addVisualElementRank,
      element_type: this.selectedVisualType,
      element_name: this.addVisualElementName,
      parent_json: JSON.stringify(updatedParentJson),
    };
    this.reportsService.updateReportJSON(payload).subscribe({
      next: (_res: any) => {
        this.toastr.success('Visual added successfully', '', {
          timeOut: 3000,
          positionClass: 'toast-top-center'
        });
        this.isAddVisualJsonPopupOpen = false;
        this.modalAddVisualJSON?.hide();
        this.setDefaultData();
        this.showDefaultLoader();
        this.getParentJSON();
      },
      error: (_err: any) => {
        this.toastr.error('Error adding visual JSON', '', {
          timeOut: 3000,
          positionClass: 'toast-top-center'
        });
      }
    });
  }

  hidepopup(type: string) {
    if(type == 'edit') {
      this.isJSONeditorPopupOpen = false;
      // this.modalEditJSON?.close?.() || this.modalEditJSON?.hide?.();
    } else if (type == 'add-visual') {
      this.isAddVisualJsonPopupOpen = false;
      this.pendingRankConflict = false;
      // this.modalAddVisualJSON?.close?.() || this.modalAddVisualJSON?.hide?.();
    }
  }

  deleteReport() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '200px';
    dialogConfig.height = 'auto';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'Delete Confirmation!',
      subTitle: 'Are you sure you want to delete this report',
      buttonName: 'Continue'
    };

    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data !== 'cancel') {
        const reportId = this.parentJSON?.id ?? null;
        const reportName = this.resolvedReportName || 'Report';
        this.reportsService.deleteTOHReport(reportId).subscribe({
          next: (_: any) => {
            this.toastr.success(`${reportName} has been deleted successfully`, '', {
              timeOut: 3000,
              positionClass: 'toast-top-center'
            });
          },
          error: (_: any) => {
            this.toastr.error('Error deleting report', '', {
              timeOut: 3000,
              positionClass: 'toast-top-center'
            });
          }
        });
      }
    });
  }

  onJsonEditorTextChange(ev: any) {
    if(this.parentJSON.id >= 0){
      const payload = {
      Report: this.resolvedReportName,
      Report_Type: 'inBuilt',
      id: this.parentJSON?.id ?? null,
      inbuilt_report_json: ev || {},
    };
    this.reportsService.updateReportParentJSON(payload).subscribe({
      next: (res: any) => {
        this.toastr.success('Report JSON updated successfully', '', {
          timeOut: 3000,
          positionClass: 'toast-top-center'
        });
        this.modalEditJSON?.hide();
        this.setDefaultData();
        this.showDefaultLoader();
        this.getParentJSON();
      },
      error: (err: any) => {
        this.toastr.error('Error updating JSON', '', {
          timeOut: 3000,
          positionClass: 'toast-top-center'
        });
      }
    });  
    }
  }
}
